// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { connect } from 'react-redux';

// app modules: components
import Button from 'components/Button';

// assets
import CssShowMore from './ShowMore.scss';
import { TRUNCATION_LIMIT } from '../../constants';

export class ShowMoreComponent extends Component {
  static propTypes = {
    backgroundColor: PropTypes.oneOf(['alabaster']),
    children: PropTypes.node.isRequired,
    childrenLength: PropTypes.number,
    className: PropTypes.string,
    displayType: PropTypes.string.isRequired,
    hideButton: PropTypes.bool,
    withFormatting: PropTypes.bool,
  };

  static defaultProps = {
    backgroundColor: null,
    childrenLength: null,
    className: '',
    hideButton: false,
    withFormatting: true,
  };

  constructor() {
    super();
    this.state = {
      show: true,
    };
  }

  toggleShow = () => {
    this.setState({
      show: !this.state.show,
    });
  };

  render() {
    const {
      children,
      className,
      childrenLength,
      displayType,
      hideButton,
      backgroundColor,
      withFormatting,
    } = this.props;
    const { show } = this.state;
    const actionClassName = classNames(
      'show-more',
      {
        'show-more--closed ': show,
        'show-more--opened': !show,
        'show-more--with-styles': withFormatting,
      },
      backgroundColor ? `show-more--background-color-${backgroundColor}` : null,
    );

    const buttonName = show ? 'Read more' : 'Show less';

    const truncatedText = (
      <div className={classNames('show-more', className)} role="none" onClick={this.toggleShow}>
        <div className={actionClassName}>{children}</div>
        {hideButton ? null : (
          <Button
            className="show-more__button"
            themeName="energized"
            themeType="clear"
            size="large"
            onClick={this.toggleShow}
          >
            {buttonName}
          </Button>
        )}
      </div>
    );

    const fullText = (
      <div className={className}>
        <div className="show-more--opened">{children}</div>
      </div>
    );

    if (
      children &&
      ((displayType === 'mobile' && childrenLength > TRUNCATION_LIMIT.MOBILE) ||
        (displayType === 'tablet' && childrenLength > TRUNCATION_LIMIT.TABLET) ||
        (displayType === 'desktop' && childrenLength > TRUNCATION_LIMIT.DESKTOP))
    ) {
      return truncatedText;
    }
    return fullText;
  }
}

const mapStateToProps = state => ({
  displayType: state.dimensions.displayType,
});

export default connect(
  mapStateToProps,
  null,
)(withStyles(CssShowMore)(ShowMoreComponent));
